import React from "react";

const Terms = () => {
  const terms = {
    title: "Terms of Use",
    sections: [
      {
        heading: "1. Introduction",
        content:
          "Welcome to the Aadya Academy School Parent Application. By accessing and using our application, you agree to comply with these Terms of Use.",
      },
      {
        heading: "2. User Responsibilities",
        content: [
          "Ensure that the information provided during registration is accurate and up-to-date.",
          "Do not use the application for any unlawful activities.",
          "Respect the privacy of other users and do not share personal information without consent.",
        ],
      },
      {
        heading: "3. Account Security",
        content:
          "You are responsible for maintaining the confidentiality of your account credentials. Notify us immediately if you suspect unauthorized access.",
      },
      {
        heading: "4. Limitation of Liability",
        content:
          "Aadya Academy is not liable for any direct, indirect, or incidental damages resulting from the use of our application.",
      },
      {
        heading: "5. Changes to Terms",
        content:
          "We reserve the right to update these Terms of Use at any time. Continued use of the application after changes indicates acceptance.",
      },
      {
        heading: "6. Contact Information",
        content:
          "If you have any questions about these Terms of Use, please contact us at aadyaacademykannur@gmail.com or call +91 890 473 2123.",
      },
    ],
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", maxWidth: "800px", margin: "auto" }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>{terms.title}</h2>

      {terms.sections.map((section, index) => (
        <div key={index}>
          <h3>{section.heading}</h3>
          {Array.isArray(section.content) ? (
            <ul>
              {section.content.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>{section.content}</p>
          )}
        </div>
      ))}

      <p><strong>By using the Aadya Academy School Parent Application, you acknowledge and agree to these Terms of Use.</strong></p>
    </div>
  );
};

export default Terms;
